import "./css/home.css";
import HomeMenu from "./../elemets/homeMenu";
import Footer from "./../footer/footer";
import { Link } from "react-router-dom"

const Home = () => {
    return (
        <div className="homePage">
            {/* Header is handled by HomeMenu component */}
            <div className="homePageMainMenuContainer">
                <HomeMenu />
            </div>

            {/* --- Hero Section --- */}
            <div className="HomepageMainUserInterfaceContainer">
                <div className="homePageMainTextContainer">
                    <div className="homePageTagLine">
                        <span className="tagLineHighlight">Real Exams,</span>
                        <span className="tagLineHighlight">Real Practice,</span>
                        <span className="tagLineHighlight">Real Success</span>
                    </div>
                    <div className="homePageSubtagLine">
                        Ace Your <span className="homePage__titleHighlight">Government Job</span> and
                        <span className="homePage__titleHighlight"> College Entrance</span> Exams
                    </div>
                    <div className="homepageUserInfo">
                        Comprehensive platform offering objective-type mock tests, previous year papers, and subject tests for both government jobs and college entrance exams. Practice in exam-compatible languages with detailed analytics.
                    </div>

                    {/* NEW: Clean Live Search Bar Simulation for Premium Look */}
                    {/* <div className="homePageSearchBarWrapper">
                        <div className="homePageSearchBar">
                            <i className="fa-solid fa-magnifying-glass searchIcon"></i>
                            <input 
                                type="text" 
                                placeholder="Search your exam (e.g., RRB NTPC, SSC...)" 
                                className="searchInput"
                                readOnly // Currently visual only
                            />
                            <Link to="/test" className="searchBtn">Explore</Link>
                        </div>
                    </div> */}

                    <div className="homePageCTAButtons">
                        <Link to="/test" className="ctaButton primaryButton">
                            <i className="fas fa-play-circle"></i> Start Free Practice
                        </Link>
                        <Link to="/course" className="ctaButton secondaryButton">
                            <i className="fas fa-book-open"></i> Explore Features
                        </Link>
                    </div>
                                        
                    {/* ORIGINAL STATS COMMENTED AS REQUESTED */}
                    {/* <div className="homePageStats">
                        <div className="statItem">
                            <span className="statNumber">10K+</span>
                            <span className="statLabel">Practice Tests</span>
                        </div>
                        <div className="statItem">
                            <span className="statNumber">500+</span>
                            <span className="statLabel">Exam Patterns</span>
                        </div>
                        <div className="statItem">
                            <span className="statNumber">98%</span>
                            <span className="statLabel">Success Rate</span>
                        </div>
                    </div> */}
                </div>

                <div className="homePageMainImageContainer">
                    <div className="homePageImageWrapper">
                        <div className="imageGlowEffect"></div>
                        <img
                            src="https://img.freepik.com/free-photo/pc-display-startup-office-desk-showing-programming-languages_482257-120128.jpg?semt=ais_hybrid&w=740&q=80"
                            alt="Student preparing for exams on laptop"
                            className="homePageMainImage"
                        />
                    </div>
                </div>
            </div>

            {/* --- NEW SECTION: How It Works (3 Simple Steps) --- */}
            <div className="homePageHowItWorksContainer">
                <div className="howItWorksHeader">
                    <h2 className="sectionMainTitle">How It Works</h2>
                    <p className="sectionSubTitle">Start your preparation journey in 3 simple steps</p>
                </div>
                
                <div className="stepsGridContainer">
                    {/* Step 1 */}
                    <div className="stepCard">
                        <div className="stepNumber">01</div>
                        <div className="stepIcon"><i className="fa-solid fa-bullseye"></i></div>
                        <h3 className="stepTitle">Select Your Exam</h3>
                        <p className="stepDescription">
                            Choose your target exam, paper, and preferred language from our organized library.
                        </p>
                    </div>
                    
                    {/* Arrow Connector (Visible on Desktop) */}
                    <div className="stepConnector"><i className="fa-solid fa-arrow-right-long"></i></div>

                    {/* Step 2 */}
                    <div className="stepCard">
                        <div className="stepNumber">02</div>
                        <div className="stepIcon"><i className="fa-solid fa-laptop-code"></i></div>
                        <h3 className="stepTitle">Attempt Practice Test</h3>
                        <p className="stepDescription">
                            Experience a real exam environment with our time-bound, pattern-matched mock tests.
                        </p>
                    </div>

                    {/* Arrow Connector */}
                    <div className="stepConnector"><i className="fa-solid fa-arrow-right-long"></i></div>

                    {/* Step 3 */}
                    <div className="stepCard">
                        <div className="stepNumber">03</div>
                        <div className="stepIcon"><i className="fa-solid fa-chart-pie"></i></div>
                        <h3 className="stepTitle">Analyze Your Score</h3>
                        <p className="stepDescription">
                            Get instant results, detailed scorecard, and solutions to track and improve your performance.
                        </p>
                    </div>
                </div>
            </div>

            {/* --- Existing Features Section --- */}
            <div className="homepageAboutWorkContainer">
                <div className="homePageServiceInfoContainer">
                    <div className="serviceIcon">
                        <i className="fa-solid fa-layer-group"></i>
                    </div>
                    <h3 className="homePageServiceTitle">Series</h3>
                    <p className="homePageserviceDescription">
                        Various practice series designed for exams, topics, and subjects. Check your scores and track learning
                        progress with weekly, monthly, and yearly analytics.
                    </p>
                </div>

                <div className="homePageServiceInfoContainer">
                    <div className="serviceIcon">
                        <i className="fa-solid fa-file-lines"></i>
                    </div>
                    <h3 className="homePageServiceTitle">Previous Papers</h3>
                    <p className="homePageserviceDescription">
                        Master exam patterns and question types through previous years' papers. Identify trends,
                        refine your strategy, and boost your chances of cracking the exam.
                    </p>
                </div>

                <div className="homePageServiceInfoContainer">
                    <div className="serviceIcon">
                        <i className="fa-solid fa-chart-line"></i>
                    </div>
                    <h3 className="homePageServiceTitle">Practice Sets</h3>
                    <p className="homePageserviceDescription">
                        Generate random practice papers to master different question types. Be ready for sudden
                        exam pattern changes and prepare strategically in advance.
                    </p>
                </div>

                <div className="homePageServiceInfoContainer">
                    <div className="serviceIcon">
                        <i className="fa-solid fa-book-open-reader"></i>
                    </div>
                    <h3 className="homePageServiceTitle">Subject Practice</h3>
                    <p className="homePageserviceDescription">
                        Subject and topic-specific practice to assess your understanding. Build mastery across all subjects
                        through focused, structured learning.
                    </p>
                </div>

                <div className="homePageServiceInfoContainer">
                    <div className="serviceIcon">
                        <i className="fa-solid fa-language"></i>
                    </div>
                    <h3 className="homePageServiceTitle">Bilingual Support</h3>
                    <p className="homePageserviceDescription">
                        Exam patterns and question papers available in multiple languages for wider accessibility and better comprehension.
                    </p>
                </div>
            </div>

            {/* --- Objectives Section --- */}
            <div className="homePageObjectivMainContainer">
                <div className="homePageObjectivTitle">
                    Career Paths We Support
                </div>

                <div className="homePageObjectivSubtitle">
                    Empowering individuals at every stage of their educational journey
                </div>

                <div className="homePageObjectivContainer">

                    <div className="homePageObjectiveInfoContainer">
                        <div className="objectiveIconContainer">
                            <i className="fa-solid fa-user-tie"></i>
                        </div>
                        <h3 className="homePageObjectiveTitle">Aspirants</h3>
                        <p className="homePageObjectiveDescription">
                            Comprehensive preparation for competitive exams and career advancement
                        </p>
                        <div className="objectiveFeatureList">
                            <span className="objectiveFeature"><i className="fa-solid fa-check"></i> Exam Strategy</span>
                            <span className="objectiveFeature"><i className="fa-solid fa-check"></i> Skill Development</span>
                            <span className="objectiveFeature"><i className="fa-solid fa-check"></i> Career Guidance</span>
                        </div>
                    </div>

                    <div className="homePageObjectiveInfoContainer">
                        <div className="objectiveIconContainer">
                            <i className="fa-solid fa-user-graduate"></i>
                        </div>
                        <h3 className="homePageObjectiveTitle">Students</h3>
                        <p className="homePageObjectiveDescription">
                            Assistance for college entrance tests and academic excellence
                        </p>
                        <div className="objectiveFeatureList">
                            <span className="objectiveFeature"><i className="fa-solid fa-check"></i> Entrance Preparation</span>
                            <span className="objectiveFeature"><i className="fa-solid fa-check"></i> Subject Mastery</span>
                            <span className="objectiveFeature"><i className="fa-solid fa-check"></i> Study Planning</span>
                        </div>
                    </div>

                    <div className="homePageObjectiveInfoContainer">
                        <div className="objectiveIconContainer">
                            <i className="fa-solid fa-user-group"></i>
                        </div>
                        <h3 className="homePageObjectiveTitle">Parents</h3>
                        <p className="homePageObjectiveDescription">
                            Support for parent-child relationships and educational guidance
                        </p>
                        <div className="objectiveFeatureList">
                            <span className="objectiveFeature"><i className="fa-solid fa-check"></i> Parenting Support</span>
                            <span className="objectiveFeature"><i className="fa-solid fa-check"></i> Stress Management</span>
                            <span className="objectiveFeature"><i className="fa-solid fa-check"></i> Adjustment Guidance</span>
                        </div>
                    </div>

                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Home;